import module from '../module';
import Constant from "../../../utils/CommonConstants";
import * as _ from 'lodash';
import {DbStorageService} from "./DbStorageService";

export class SessionStorageService {
    static $inject = ['$cookies', 'cartonomyConfig'];

    constructor(cookies, cartonomyConfig) {
        this.cookiesService = cookies;
        this.cartonomyConfig = cartonomyConfig;
        this.storageCopy = {};

        this.checkLocalStorage();
        if (window.localStorage.getItem(Constant.SessionStorage.CARTONOMY_BUILD_TIME) !== this.cartonomyConfig.buildTime ||
            window.localStorage.getItem(Constant.SessionStorage.CARTONOMY_BUILD_VERSION) !== this.cartonomyConfig.version) {
            this.resetVersionStorage();
        }
    }

    checkLocalStorage() {
        if (window.localStorage.length) {
            for (let i in window.localStorage) {
                this.storageCopy[i] = window.localStorage[i];
            }
        } else {
            for (let i in this.storageCopy) {
                window.localStorage.setItem(i, this.storageCopy[i]);
            }
        }

        setTimeout(() => this.checkLocalStorage(), 60 * 1000);
    }

    resetVersionStorage() {
        window.localStorage.setItem(Constant.SessionStorage.CARTONOMY_BUILD_TIME, this.cartonomyConfig.buildTime);
        window.localStorage.setItem(Constant.SessionStorage.CARTONOMY_BUILD_VERSION, this.cartonomyConfig.version);
    }

    getStorageKey(key) {
        if (this.cartonomyConfig.externalStoreMode) {
            return `${this.cartonomyConfig.externalStoreUrl}__${key}`;
        }

        return key;
    }

    get(key) {
        if (window.localStorage) {
            return window.localStorage.getItem(this.getStorageKey(key));
        } else {
            return this.cookiesService.get(this.getStorageKey(key));
        }
    }

    set(key, value) {
        if (window.localStorage) {
            window.localStorage.setItem(this.getStorageKey(key), value);
        } else {
            this.cookiesService.put(this.getStorageKey(key), value);
        }
        return value;
    }

    clear(key) {
        if (window.localStorage) {
            window.localStorage.removeItem(this.getStorageKey(key));
        } else {
            this.cookiesService.remove(this.getStorageKey(key));
        }
    }

    clearAll() {
        window.localStorage.clear();
        window.sessionStorage.clear();
        this.resetVersionStorage();
    }

    exists(key) {
        return !_.isUndefined(this.get(key)) && !_.isNull(this.get(key));
    }
}

module.service('SessionStorage', SessionStorageService);



// WEBPACK FOOTER //
// ./src/modules/shared/services/SessionStorageService.js